<template>
  <b-modal @hidden="clearForm" centered ref="ticketForm" size="lg" id="ticketForm" hide-header hide-footer>
    <h1 class="text-left">{{ticketTitle()}}</h1>
    <hr>
    <b-form class="text-left" @submit.stop.prevent="handleSubmit">
      <b-form-group label="Ticket Name">
        <b-form-input type="text"
                      v-model="ticketObject.name"
                      required>
        </b-form-input>
      </b-form-group>
      <b-form-group label="Notes">
        <b-form-textarea v-model="ticketObject.description" :max-rows="6">
        </b-form-textarea>
      </b-form-group>
      <b-form-group label="Clients">
        <v-select multiple v-model="client_ids" value="" :options="clients" required />
        <b-form-checkbox v-model="all_clients">All Clients</b-form-checkbox>
        <b-form-checkbox v-model="all_my_clients">My Clients</b-form-checkbox>
        <b-form-checkbox v-model="ticketObject.internal">Internal Project (no clients apply)</b-form-checkbox>
      </b-form-group>
      <hr>
      <b-form-group label="Teams">
        <v-select v-model="selectedTeam" :options="teams"></v-select>
      </b-form-group>
      <b-form-group label="Create Tasks from Template Collection">
        <v-select multiple v-model="task_template_collection_ids" value="" :options="template_collections"></v-select>
      </b-form-group>
      <b-form-group v-if="ticketObject.message_id" label="Task Board">
        <b-form-select v-model="task_board_id" :options="boards_collection"></b-form-select>
      </b-form-group>
      <b-form-group v-if="task_template_collection_ids.length > 0">
        Task Owner
        <SingleUserSelector v-on:user-change="owner = $event" v-on:user-remove="owner = {}" :parent="ticketObject"/>
      </b-form-group>
      <template v-if="!ticketObject.message_id">
        <hr>
        <b-form-group label="Ticket Board">
          <b-form-select v-model="ticketObject.board_id" :options="boards_collection"></b-form-select>
        </b-form-group>
      </template>
      <template v-if="currentUser.roles.includes('admin', 'manager')">
        <hr>
        <b-form-group>
          <b-form-checkbox v-model="ticketObject.recurring">Recurring Ticket</b-form-checkbox>
        </b-form-group>
        <template v-if="ticketObject.recurring">
          <b-form-group>
            Recurring Frequency
            <b-form-select v-model="ticketObject.interval" :options="recurring_options"></b-form-select>
          </b-form-group>
          <b-form-group>
            Day - Next ticket date: <b>{{ ticketObject.formatted_recurring_date}}</b>
            <b-form-select v-model="ticketObject.day" :options="day_options"></b-form-select>
          </b-form-group>
        </template>
      </template>
      <hr>
      <template v-if="currentUser.roles.includes('reviewer')">
        <b-form-group>
          Review Status
          <b-form-select v-model="ticketObject.review_request" :options="review_options"></b-form-select>
        </b-form-group>
      </template>
      <section>
        <TicketAudit v-for="audit in ticketObject.request_audits"
                     :key="audit.created_at"
                     :audit="audit"/>
      </section>
      <br>
      <b-button class="create-ticket-btn" type="submit">{{submitText()}}</b-button>
      <b-button type="reset" variant="warning" @click="initTicket">Reset</b-button>
      <b-button v-if="!ticketObject.message_id && ticketObject.id" type="reset" variant="danger" @click="deleteTicket">Delete</b-button>
      <b-btn class="float-right" @click="hideModal">Close</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import { collectionsMixins } from '@/mixins/collectionsMixins'
import { helpersMixins } from '@/mixins/helpersMixins'
import { mapGetters } from 'vuex'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
import TicketAudit from './TicketAudit'
export default {
  name: 'TicketForm',
  mixins: [collectionsMixins, helpersMixins],
  props: {
    ticket: Object
  },
  components: {
    SingleUserSelector,
    TicketAudit
  },
  data: function () {
    return {
      clone: false,
      template_collections: [],
      task_template_collection_ids: [],
      task_board_id: '',
      boards_collection: [],
      client_ids: [],
      teams: [],
      selectedTeam: [],
      ticketObject: {
        name: '',
        message_id: null,
        board_id: null,
        description: '',
        internal: false,
        review_request: 'unrequested',
        interval: null,
        day: null,
        recurring: null
      },
      owner: {},
      all_clients: null,
      all_my_clients: null,
      review_options: ['unrequested', 'requested', 'approved', 'disapproved'],
      recurring_options: [
        {text: 'weekly', value: 'week'},
        {text: 'monthly', value: 'month'},
        {text: 'quarterly', value: 'quarter'},
        {text: 'yearly', value: 'year'}
      ]
    }
  },
  watch: {
    all_clients: function () {
      if (this.all_clients === true) {
        this.client_ids = this.clients
      } else {
        this.client_ids = []
      }
    },
    all_my_clients: function () {
      if (this.all_my_clients === true) {
        this.client_ids = this.my_clients
      } else {
        this.client_ids = []
      }
    },
    ticket () {
      this.initTicket()
    },
    selectedTeam () {
      let params = this.selectedTeam ? `?team_id=${this.selectedTeam.value}` : ''
      this.templateCollections(params)
    }
  },
  created () {
    this.loadCollections()
    this.getTeams()
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser', clients: 'clients', my_clients: 'my_clients' }),
    day_options () {
      var options
      switch (this.ticketObject.interval) {
        case 'week':
          options = [
            {text: 'Monday', value: 0},
            {text: 'Tuesday', value: 1},
            {text: 'Wednesday', value: 2},
            {text: 'Thursday', value: 3},
            {text: 'Friday', value: 4},
            {text: 'Saturday', value: 5},
            {text: 'Sunday', value: 6}
          ]
          break
        case 'month':
          options = _.range(1, 32)
          break
        case 'quarter':
          options = _.range(1, 92)
          break
        case 'year':
          options = _.range(1, 366)
          break
        default:
          options = []
      }
      return options
    }
  },
  methods: {

    initTicket (params) {
      if (this.ticket) {
        this.ticketObject = this.ticket
        this.task_board_id = this.ticket.task_board_id
        if (this.ticket.clients) {
          this.client_ids = this.ticket.clients.map(function (data) {
            return { value: data.id, label: data.name }
          })
        } else {
          this.client_ids = []
        }
        if (!_.isEmpty(this.ticket.message) && !this.ticket.id) {
          this.ticketObject.message_id = this.ticket.message.id
          this.ticketObject.name = this.ticket.message.subject
          this.task_board_id = this.ticket.message.mailbox.default_board_id
        }
        if (this.ticket.tasks) {
          if (this.ticket.tasks.length > 0 && !this.task_board_id) {
            this.task_board_id = this.ticket.tasks[0].board_id
          }
        }
        if (this.ticket.recurring_options) {
          this.ticketObject.day = this.ticket.recurring_options.day
          this.ticketObject.interval = this.ticket.recurring_options.interval
        }
      }
      if (params && params.clone) {
        this.clone = true
      }
    },

    ticketTitle () {
      if (this.ticketObject.id && !this.clone) {
        return 'Edit Ticket #' + this.ticketObject.id
      } else if (this.clone) {
        return 'Clone Ticket'
      } else {
        return 'New Ticket'
      }
    },
    submitText () {
      if (this.clone) {
        return 'Clone Ticket'
      } else if (this.ticketObject.id) {
        return 'Update Ticket'
      } else {
        return 'Create Ticket'
      }
    },
    handleSubmit () {
      if (this.client_ids.length === 0 && !this.ticketObject.internal) {
        alert('You must select a client or select Internal Project.')
        return
      }
      this.client_ids = this.client_ids.map(function (data) {
        return data.value
      })
      if (this.task_template_collection_ids.length > 0) {
        this.task_template_collection_ids = this.task_template_collection_ids.map(function (data) {
          return data.value
        })
        if (!this.ticketObject.id && this.ticket.board_id) {
          this.task_board_id = this.ticket.board_id
        }
      }
      this.ticket.message = {}
      var params
      params = this.setParams()
      if (this.clone) {
        params.cloned_ticket_id = this.ticketObject.id
        params.ticket.id = null
        params.ticket.message_id = null
        params.ticket.board_id = params.board_id
      }
      if (this.ticketObject.id) {
        this.ticketObject.client_ids = this.client_ids
        params = this.setParams()
        this.$http.put('/tickets/' + this.ticketObject.id, params)
          .then(response => this.updateSuccessful(response))
          .catch(e => { console.log(e.response) })
      } else {
        this.$http.post('/tickets', params)
          .then(response => this.createSuccessful(response))
          .catch(e => { console.log(e.response) })
      }
    },

    deleteTicket () {
      var del = confirm('Are you sure?')
      if (del === true) {
        if (this.ticketObject.message_id) {
          return
        }
        var vm = this
        this.$http.delete('/tickets/' + this.ticketObject.id)
          .then(function (response) {
            vm.$root.$emit('ticketDeleted', vm.ticketObject.id)
            vm.hideModal()
          })
          .catch(e => { console.log(e.response) })
      }
    },
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'ticketForm')
      this.clearForm()
    },
    updateSuccessful (response) {
      this.hideModal()
      this.$root.$emit('ticketWasUpdated', response.data)
    },
    createSuccessful (response) {
      this.hideModal()
      this.$root.$emit('ticketWasCreated')
    },
    loadCollections () {
      this.boardsCollection()
      this.templateCollections()
    },
    setParams () {
      var params = { ticket: this.ticketObject }
      if (this.task_template_collection_ids.length > 0) {
        params.task_template_collection_ids = this.task_template_collection_ids
        if (this.owner.id) {
          params.user_id = this.owner.id
        }
      }
      if (this.task_board_id) {
        params.board_id = this.task_board_id
      } else if (this.ticketObject.board_id) {
        params.board_id = this.ticketObject.board_id
      }
      if (this.client_ids) {
        params.client_ids = this.client_ids
      }
      if (this.clone) {
        params.clone = true
      }
      return params
    },
    clearForm () {
      this.ticketObject = {
        name: '',
        message_id: null,
        board_id: null,
        description: '',
        internal: false
      }
      this.task_template_collection_ids = []
      this.task_board_id = ''
      this.client_ids = []
      this.selectedTeam = []
    }
  },

  mounted () {
    this.$root.$on('ticketEdit', () => {
      this.loadCollections()
      this.initTicket()
    })
    this.$root.$on('ticketClone', () => {
      this.loadCollections()
      this.initTicket({clone: true})
    })
  },
  beforeDestroy () {
    this.$root.$off('ticketEdit')
    this.$root.$off('ticketClone')
  }
}
</script>

<style scoped>
.create-ticket-btn {
  background-color: #57B2CD;
  border-color: #57B2CD;
}
.create-ticket-btn:hover {
  background-color: #3D92AB;
}
.modal-content {
  max-width: 600px;
  margin: 0 auto;
  padding: 10px;
}
</style>
<style>
.v-select .dropdown-toggle::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TicketForm.vue